import { useAtomValue } from 'jotai';
import { luraSignUserAtom } from '../../store/global/atoms';

export const useLuraSignUserData = () => { 
  const luraSignUserData = useAtomValue(luraSignUserAtom);

  return {
    userSignDataResponse: luraSignUserData.data,
    getLuraSignUserData: luraSignUserData.mutate,
    getLuraSignUserDataAsync: luraSignUserData.mutateAsync,
    isLoading: luraSignUserData.isPending,
    error: luraSignUserData.error,
  };
};
